import { render, staticRenderFns } from "./RpsTable.vue?vue&type=template&id=4f73bd86"
import script from "./RpsTable.vue?vue&type=script&lang=ts"
export * from "./RpsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports